export default __webpack_public_path__ + "static/search-collapsed-9e5193ceb69f02021e9ba8eed1816968.png";